var map = {
	"./pack1.png": 24673,
	"./pack10.png": 71218,
	"./pack2.png": 58785,
	"./pack3.png": 47401,
	"./pack4.png": 46941,
	"./pack5.png": 61436,
	"./pack6.png": 441,
	"./pack7.png": 62262,
	"./pack8.png": 28948,
	"./pack9.png": 72872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90852;